import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, Globe, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative mt-24 bg-brand-moss text-brand-cream"
    >
      <svg
        viewBox="0 0 1440 70"
        preserveAspectRatio="none"
        className="absolute -top-px left-0 w-full h-12 text-brand-moss"
        aria-hidden="true"
      >
        <path
          d="M0,40 C200,10 360,70 600,40 C840,10 1040,70 1240,30 C1340,10 1400,30 1440,20 L1440,70 L0,70 Z"
          fill="currentColor"
        />
      </svg>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 pt-20 pb-10 grid lg:grid-cols-4 gap-10">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img
              src="/assets/logo_hires.png"
              alt="414, LLC"
              className="w-16 h-16 object-contain"
            />
            <span className="font-serif text-2xl text-brand-cream">
              414, <span className="text-brand-gold italic">LLC</span>
            </span>
          </div>
          <p className="font-serif italic text-xl text-brand-cream/80 max-w-md leading-relaxed">
            &ldquo;Cultivating beauty, inspiring wellness, and creating with intention.&rdquo;
          </p>
          <p className="mt-6 text-sm text-brand-cream/70 max-w-md">
            A faith-driven studio supporting Autism Awareness. Each candle,
            planter and oil is hand-poured and hand-arranged with care.
          </p>
        </div>

        <div>
          <h4 className="font-serif text-lg text-brand-gold mb-4">Sanctuary</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop/candles" className="hover:text-brand-gold-light">Scented Candles</Link></li>
            <li><Link to="/shop/planters" className="hover:text-brand-gold-light">Floral Planters</Link></li>
            <li><Link to="/shop/oils" className="hover:text-brand-gold-light">Hair Growth Oils</Link></li>
            <li><Link to="/membership" className="hover:text-brand-gold-light">Circle of Intention</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-lg text-brand-gold mb-4">Stay close</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="tel:8706354407" className="hover:text-brand-gold-light inline-flex items-center gap-2"><Phone className="w-4 h-4" /> 870-635-4407</a></li>
            <li><a href="mailto:414llc.info@gmail.com" className="hover:text-brand-gold-light inline-flex items-center gap-2"><Mail className="w-4 h-4" /> 414llc.info@gmail.com</a></li>
            <li><a href="https://www.414llc.com" className="hover:text-brand-gold-light inline-flex items-center gap-2"><Globe className="w-4 h-4" /> www.414llc.com</a></li>
            <li><a href="https://facebook.com/414LLC" target="_blank" rel="noreferrer" className="hover:text-brand-gold-light inline-flex items-center gap-2"><Facebook className="w-4 h-4" /> @414LLC</a></li>
            <li><a href="https://instagram.com/414.llc_" target="_blank" rel="noreferrer" className="hover:text-brand-gold-light inline-flex items-center gap-2"><Instagram className="w-4 h-4" /> @414.llc_</a></li>
          </ul>
        </div>
      </div>

      <div className="relative border-t border-brand-cream/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 text-center">
          <p className="font-serif italic text-sm text-brand-cream/85">
            Thank you for supporting a small business built on faith, hard work, and love. <span className="text-brand-gold">♡</span>
          </p>
        </div>
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 border-t border-brand-cream/10 flex flex-col sm:flex-row gap-3 justify-between items-center text-xs text-brand-cream/55">
          <span>© {new Date().getFullYear()} 414, LLC · Rooted in Faith · Growing with Purpose.</span>
          <span className="font-script text-lg text-brand-gold">honoring God in everything we do</span>
        </div>
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4 border-t border-brand-cream/10 text-center text-[11px] uppercase tracking-[0.35em] text-brand-cream/45">
          Powered by{" "}
          <a
            href="https://traceelements.dev"
            target="_blank"
            rel="noreferrer"
            data-testid="powered-by-traceelements"
            className="text-brand-gold hover:text-brand-gold-light transition-colors"
          >
            TraceElements
          </a>
        </div>
      </div>
    </footer>
  );
}
